export default {
  SET_PROVIDERS: 'SET_PROVIDERS',
  SET_PROVIDERID: 'SET_PROVIDERID',
  SET_STATUSES: 'SET_STATUSES',
  SET_YEARS: 'SET_YEARS',
  SET_PROVIDERSLIST: 'SET_PROVIDERSLIST',

  SET_PROPOSAL_PROVIDERS: 'SET_PROPOSAL_PROVIDERS',
  SET_PROPOSAL_ACADEMICYEARS: 'SET_PROPOSAL_ACADEMICYEARS',
  SET_PROPOSAL_DEFAULTACADEMICYEAR: 'SET_PROPOSAL_DEFAULTACADEMICYEAR',
  SET_PROPOSAL_AREAS: 'SET_PROPOSAL_AREAS',
  SET_PROPOSAL_EVALUATORS: 'SET_PROPOSAL_EVALUATORS',
  SET_PROPOSAL_STATUSES: 'SET_PROPOSAL_STATUSES',
  SET_MUNICIPALITIES: 'SET_MUNICIPALITIES',
  SET_COMPANYTYPES: 'SET_COMPANYTYPES',
  SET_CAN_BE_ASSIGNED_TO_EVALUATORS: 'SET_CAN_BE_ASSIGNED_TO_EVALUATORS',
  SET_PREVIEW_LIST_PROPOSAL_ASSIGNED_TO_EVALUATORS:
    'SET_PREVIEW_LIST_PROPOSAL_ASSIGNED_TO_EVALUATORS',
  SET_SERVICE_LOCATION_FILTERS: 'SET_SERVICE_LOCATION_FILTERS',
  SET_COMPANY_SSN: 'SET_COMPANY_SSN',
};
